module.exports = __webpack_public_path__ + "static/media/alerta-taller-verde.7914de78.svg";